import React from 'react'
// import LoaderButton from '../../components/LoaderButton'
// import FormViewer from '../../components/FormViewer'
import { translate } from "../../utils/useful";
// import Responsive from '../../components/Responsive';
// import TableViewer from '../../components/TableViewer';
// import SwitchInput from '../../components/inputs/SwitchInput';
// import StageActionButton from '../../components/partials/StageActionButton';
// import AddPermissionModal from '../../modals/AddPermissionModal';
// import SearchUsersModal from '../../modals/SearchUsersModal';
// import SearchGroupsModal from '../../modals/SearchGroupsModal';
// import SidebarView from '../../components/SidebarView';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import ActionButton from '../../components/partials/ActionButton';
// import CAHeader from '../../components/header/CAHeader';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
// import TextInput from '../../components/inputs/TextInput';
// import { nanoid } from 'nanoid';
// import SelectInput from '../../components/inputs/SelectInput';
// import Collapsible from 'react-collapsible';
// import CheckboxInput from '../../components/inputs/CheckboxInput';
// import FilterEditorInput from '../../components/inputs/FilterEditorInput';
// import RadiusSelectInput from '../../components/inputs/RadiusSelectInput';
// import HelpButton from '../../components/HelpButton';
import PermissionsView from '../../components/PermissionsView';
import HttpServices from '../../utils/Http.services';
import CustomLoader from '../../components/CustomLoader';
import SwitchInput from '../../components/inputs/SwitchInput';

class FramePermissions extends React.Component {
    state = {

        customAccess: {

        },

        frames: [],

        tabsView: {},

        admins: [],
        users: [],
        public: true,

        permissionsObject: {},


    }

    componentDidMount() {
        let me = this.props.user?.info
        // let admins
        let users
        let publicStatus
        let owner

        this.init()



        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                // title: '{{lang}}New Inquery',
                headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.cancel(),
                // 'title': this.props.description ?? 'Create Applet | Admins Access',
                // topHeaderComponent: this.topHeaderComponent,

            })
        }


        // if (this.props.initData?.permissions && Array.isArray(this.props.initData?.permissions?.admins) && this.props.initData?.permissions?.admins?.length > 0) {
        //     // console.log('this.props.initData99', this.props.initData)
        //     admins = this.props.initData?.permissions?.admins
        //     // users = this.props.initData?.permissions?.users
        //     // publicStatus = this.props.initData?.permissions?.public
        //     // owner = this.props.initData?.permissions?.owner
        // } else {

        //     if (this.props.variables?.appletId) {

        //         this.getAppletRoles()

        //     } else {
        //         // admins = [{ name: 'Owner', id: 'owner', mainAccess: true, hubs: [{ _id: me?._id, image: me?.image, fullname: me?.fullname, username: me?.username, type: 'user', owner: true }], permissions: '*' }]
        //         admins = [
        //             { name: 'Full access', id: 'owner', locked: true, type: 'role', mainAccess: true, hubs: [{ _id: me?._id, image: me?.image, fullname: me?.fullname, username: me?.username, type: 'user', owner: true }], permissions: [] },
        //             { name: 'General', id: 'general', type: 'role', hubs: [], permissions: [] }
        //         ]

        //         users = []
        //         publicStatus = true
        //         owner = me?._id
        //     }
        // }



        let frames = [this.props.page]
        this.setState({ frames })

        // console.log(this.props.initData)
        // if (admins && Array.isArray(this.props.initData?.frames)) {
        //     frames = this.props.initData?.frames

        //     frames.forEach(frame => {
        //         if (frame.headers && !frame.fields) {
        //             frame.fields = frame.headers

        //         }

        //         if (frame.title && !frame.name) {
        //             frame.name = frame.title

        //         }

        //         if (frame.key && !frame.id) {
        //             frame.id = frame.key

        //         }

        //         if (!this.props.initData?.permissions) {
        //             admins.forEach(admin => {
        //                 let access = '*'
        //                 if (!admin.locked && frame.pageType == 'collection') {
        //                     access = { view: '*', create: '*', edit: '*', remove: '*' }
        //                 }
        //                 admin.permissions.push({ id: frame.id, type: 'frame', pageType: frame.pageType, access: access })
        //             });
        //         }
        //     });
        // }

        // if (!admins || !admins[0]) {
        //     return
        // }
        // admins[0].permissions.push({ id: "applet", type: 'applet', access: '*' })

        // this.setState({ admins, frames, users, owner, public: publicStatus }, () => {
        // })




    }



    init = () => {

        // TO DO: fetch applet permissions
        // console.log({ applet: this.props.variables.appletId, frame: this.props.page._id })
        this.setState({ isLoading: true })
        HttpServices.request('getFramePermissions', { applet: this.props.variables.appletId, frame: this.props.page._id }, (fetchResult, fetchError) => {

            this.setState({ isLoading: false })

            console.log('fetchError', fetchError)
            console.log('fetchResult', fetchResult)


            if (fetchError) {
                switch (fetchError?.key) {
                    case 'permissionDenied':
                        this.setState({ permissionDenied: true })
                        break;
                    default:

                        break;
                }
                return
            }
            let admins = fetchResult?.info ? fetchResult?.info : []
            this.setState({ admins: admins, userPerspective: this.props.page.userPerspective })
        })
    }


    setAdmins = (admins, cb) => {
        this.setState({ admins }, () => {
            if (cb) {
                cb()
            }
        })
    }


    headerIdentityComponent = () => {
        return (
            <div className='white d-flex flex-column' >
                <p className="text-semibold text-small">{translate("Permissions and access")}</p>
                <p className="text-semibold text-smallest">{translate(this.props.name)}</p>
                {/* <input onChange={(e) => this.setName(e.target.value)} required={true} value={this.state.name} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('Insert name ...')} /> */}
            </div>
        )
    }

    // getAppletRoles = () => {

    //     // console.log("variables", this.props.variables)
    //     let body = { applet: this.props.variables?.appletId }

    //     this.setState({ isLoadingRoles: true })
    //     HttpServices.request('getAppletRoles', body, (fetchResult, fetchError) => {

    //         this.setState({ isLoadingRoles: false })

    //         if (fetchError) {
    //             return
    //         }
    //         let roles = fetchResult.info
    //         let admins = []
    //         let frames = this.props.frames


    //         roles.forEach(role => {
    //             let access = '*'
    //             let admin

    //             if (Array.isArray(frames) && role.locked == true) {
    //                 admin = role

    //                 frames.forEach(frame => {

    //                     admin.permissions.push({ id: frame.id, type: 'frame', pageType: frame.pageType, access: access })

    //                 });
    //                 admins.push(admin)

    //             }

    //         });

    //         this.setState({ frames, admins })
    //     })

    // }



    onNextStage = () => {
        if (this.props.handleNextStage) {
            this.props.handleNextStage({ admins: this.state.admins, users: this.state.users, })
        }
        else {
            this.nextStage()
        }
    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    isLoading={this.state.isLoadingPost}
                    // onClick={() => this.props.nextStage ? this.props.nextStage({ admins: this.state.admins, users: this.state.users, }) : this.nextStage()}
                    onClick={this.updatePermissions}
                    title={translate("Save")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }


    updatePermissions = () => {

        if (!this.state.isLoadingPost) {
            this.setState({ isLoadingPost: true }, () => {
                if (this.props.setHeader) {
                    this.props.setHeader("dummy", 1)
                }
            })


            // console.log({ applet: this.props.variables.appletId, frame: this.props.page._id, permissions: { admins: this.state.admins } })

            HttpServices.request('updateFramePermissions', { applet: this.props.variables.appletId, frame: this.props.page._id, permissions: { admins: this.state.admins }, userPerspective: this.state.userPerspective }, (fetchResult, fetchError) => {
                this.setState({ isLoadingPost: false }, () => {
                    if (this.props.setHeader) {
                        this.props.setHeader("dummy", 1)
                    }
                })
                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.updateFailed', description: fetchError.message })
                    return
                }


                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.updatedSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })

            })
        }
    }



    // setHeader = (key, value) => {
    //     if (this.header) {
    //         if (typeof key == 'object') {
    //             let object = {
    //                 showSettings: true,
    //                 showFrames: 'static'
    //             }
    //             if (this.props.defaultHeaderConfig) {
    //                 object = { ...this.props.defaultHeaderConfig }
    //             }
    //             for (const [okey, ovalue] of Object.entries(key)) {
    //                 object[okey] = ovalue
    //             }
    //             if (object.showSettings && this.props.showSettings) {
    //                 object.showSettings = this.props.showSettings
    //             }
    //             this.setState({ headerConfig: object }, () => {
    //                 this.header.forceUpdate()
    //             })
    //         }
    //         else {
    //             this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
    //                 this.header.forceUpdate()
    //             })
    //         }
    //     }
    // }


    // componentWillUnmount() {
    // }


    nextStage = () => {

        // TODO: Permissions

        let data = {
            admins: this.state.admins,
            // users: this.state.users,
            // publicPermissions: this.state.public,
        }

        let frames = this.state.frames
        // console.log(data)


        // let data = this.form.getForm()
        if (data) {
            // console.log('dseklnfjdnjk', this.props)
            this.props.setData({ permissions: data, frames }, () => {
                // this.props.nextStage()
                // console.log('permissionspermissions', this.props.initData)

                if (this.props.continue) {
                    this.props.continue(this.props.stageName)
                } else {

                    if (this.props.changeStage) {
                        if (Array.isArray(this.props.initData.features) && this.props.initData.features[0] == 'Inquiry') {
                            this.props.changeStage('info')
                        }
                        else {
                            this.props.changeStage('formType')
                        }
                    }
                }


            })
        }
    }


    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }



    // setAdmins = (admins, cb) => {
    //     this.setState({ admins }, () => {
    //         if (cb) {
    //             cb()
    //         }
    //     })
    // }

    changeUserPerspective = (key, value) => {
        this.setState({ userPerspective: value })
    }


    render() {

        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }

        let user = this.props.initData?.hub ?? this.props.user?.info?._id
        variables.user = user
        variables.targetId = user


        return (
            <div className=' w-100 h-100 window-content-radius window-content-radius' style={{ backgroundColor: '#f0f0f0' }}>
                <div className=" w-100 h-100 scroll-no-scrollbar pb-5 position-relative  flex-column window-content-radius flexc flex-column pt-4" style={{}}>

                    <div className='w-100 br-20' style={{ maxWidth: 650, }}>
                        {this.state.permissionDenied && (
                            <p className='pt-5 text-center text-semibold text-semibig'>{translate("Permission Denied")}</p>
                        )}

                        {this.state.isLoading && (
                            <div className='flexcc pt-5'>
                                <CustomLoader isLoading={true} />
                            </div>
                        )}

                        {!this.state.isLoading && !this.state.permissionDenied && (
                            <div className=' w-100 flexc flex-column pt-4' >

                                <div className='w-100' >
                                    <div className='d-flex mb-4 px-4 py-4 br-20' style={{ background: '#fff', }}>
                                        <SwitchInput data={this.state.userPerspective} header={{ key: 'userPerspective', information: { size: 'small', } }} changeValue={this.changeUserPerspective} />
                                        <div className='mld-3'>
                                            <p className='text-normal text-bold'>{translate("Activate user perspective")}</p>
                                            <p className='text-smaller mt-1 text-semibold' style={{ color: '#999' }}>{translate("When the user perspective is active, it means this page is accessible to the public for viewing. Other admin options can be managed using the section below.")}</p>
                                        </div>
                                    </div>
                                    <div className='px-4 mb-2 opacity-5'>
                                        <p className='text-normal text-bold '>{translate("Admin access")}</p>
                                    </div>
                                    <div className=' mb-4 px-4 py-2 br-20' style={{ background: '#fff', }}>
                                        <PermissionsView maxWidth={650} frames={this.state.frames} width={this.props.width} admins={this.state.admins} setAdmins={this.setAdmins} applet={false} defaultOpen={false} type={"frame"} variables={this.props.variables} />
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>

        )
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FramePermissions);
